import { connect } from 'react-redux';

import { State as StoreState } from 'store/state';

import Component from './component';

export interface Props extends ParentProps {
    state: {
        authToken?: string;
    };
}

export interface ParentProps { }

const mapStateToProps = (state: StoreState, ownProps?: Props): object => {
    return {
        state: {
            authToken: state.user.authToken,
        },
    };
};

Component.defaultProps = {};
export default connect(mapStateToProps, null)(Component);
